// import React from 'react';
// import { useLocation } from 'react-router-dom';
// import './issueDetails.css'

// const IssueDetails = () => {
//   const location = useLocation();
//   const { issue } = location.state || {};

//   if (!issue) {
//     return <p>Issue not found.</p>;
//   }

//   return (
//     <div className="issue-details">
//       <h1>{issue.title}</h1>
//       <img src={issue.coverImage} alt={`${issue.title} Cover`} />
//       <p>
//         <a href={issue.link} target="_blank" rel="noopener noreferrer">
//           Read the issue
//         </a>
//       </p>
//     </div>
//   );
// };

// export default IssueDetails;






// import React, { useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import { FaInstagram, FaLinkedin, FaReddit, FaPinterest } from 'react-icons/fa';
// import './issueDetails.css';

// const IssueDetails = () => {
//   const location = useLocation();
//   const { issue } = location.state || {};
//   const [activeTab, setActiveTab] = useState('Description');

//   if (!issue) {
//     return <p>Issue not found.</p>;
//   }

//   const renderTabContent = () => {
//     switch (activeTab) {
//       case 'Description':
//         return (
//           <p>
//             Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
//             incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.
//             Risus commodo viverra maecenas accumsan lacus vel facilisis.
//           </p>
//         );
//       case 'Credits':
//         return (
//           <ul>
//             <li><strong>Publication date:</strong> December 05, 2024</li>
//             <li><strong>Publisher:</strong> Casemate</li>
//             <li><strong>Page count:</strong> 384</li>
//             <li><strong>Language:</strong> English</li>
//             <li><strong>EPUB ISBN:</strong> 9781636244747</li>
//             <li><strong>Paper ISBN:</strong> 9781636244730</li>
//             <li><strong>File size:</strong> 13 MB</li>
//           </ul>
//         );
//       case 'Details':
//         return (
//           <ul>
//             <li><strong>Publication date:</strong> December 05, 2024</li>
//             <li><strong>Publisher:</strong> Casemate</li>
//             <li><strong>Page count:</strong> 384</li>
//             <li><strong>Language:</strong> English</li>
//             <li><strong>EPUB ISBN:</strong> 9781636244747</li>
//             <li><strong>Paper ISBN:</strong> 9781636244730</li>
//             <li><strong>File size:</strong> 13 MB</li>
//           </ul>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="issue-details section__padding-issue">
//       <h1 className="issues-page__title" style={{ fontFamily: 'Poppins-Medium' }}>Issues</h1>
//       <hr className="issues-page__divider-issue" />
//       <div className="issue-details__container">
//         <div className="issue-details__left">
//           <img src={issue.coverImage} alt={`${issue.title} Cover`} className="issue-details__cover" />
//           <button className="issue-details__button">Read Full Magazine</button>
//           <button className="issue-details__button issue-details__button--secondary">
//             Purchase the Hardcopy
//           </button>
//           <div className="issue-details__social">
//             <a href="#" className="issue-details__social-link">
//               <FaInstagram />
//             </a>
//             <a href="#" className="issue-details__social-link">
//               <FaLinkedin />
//             </a>
//             <a href="#" className="issue-details__social-link">
//               <FaReddit />
//             </a>
//             <a href="#" className="issue-details__social-link">
//               <FaPinterest />
//             </a>
//           </div>
//         </div>
//         <div className="issue-details__right">
//           <p className="issue-details__subtitle">Insulate Ukraine emerged from an approach of focusing</p>
//           <h1 className="issue-details__title">{issue.title}</h1>
//           <div className="issue-details__tags">
//             <span className="issue-details__tag">Graphic Design</span>
//             <span className="issue-details__tag">Industrial Design</span>
//             <span className="issue-details__tag">Interior Design</span>
//             <span className="issue-details__tag">Furniture Design</span>
//           </div>
//           <div className="issue-details__tabs">
//             {['Description', 'Credits', 'Details'].map((tab) => (
//               <button
//                 key={tab}
//                 className={`issue-details__tab ${activeTab === tab ? 'active' : ''}`}
//                 onClick={() => setActiveTab(tab)}
//               >
//                 {tab}
//               </button>
//             ))}
//           </div>
//           <hr className="issues-page__divider-issue-sec" />
//           <div className="issue-details__content">
//             {renderTabContent()}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default IssueDetails;






import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaInstagram, FaLinkedin, FaReddit, FaPinterest } from 'react-icons/fa';
import './issueDetails.css';

const IssueDetails = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { issue } = location.state || {};
  const [activeTab, setActiveTab] = useState('Description');

  if (!issue) {
    return <p>Issue not found.</p>;
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Description':
        return (
          <p style={{fontFamily: "Poppins-Light", fontSize: '14px', color: "#000000", lineHeight: "1.3"}}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.
            Risus commodo viverra maecenas accumsan lacus vel facilisis.
          </p>
        );
      case 'Credits':
        return (
          <ul style={{fontFamily: "Poppins-Light", fontSize: '14px', color: "#000000", lineHeight: "1.3"}}>
            <li><strong>Publication date:</strong> December 05, 2024</li>
            <li><strong>Publisher:</strong> Casemate</li>
            <li><strong>Page count:</strong> 384</li>
            <li><strong>Language:</strong> English</li>
            <li><strong>EPUB ISBN:</strong> 9781636244747</li>
            <li><strong>Paper ISBN:</strong> 9781636244730</li>
            <li><strong>File size:</strong> 13 MB</li>
          </ul>
        );
      case 'Details':
        return (
          <ul style={{fontFamily: "Poppins-Light", fontSize: '14px', color: "#000000", lineHeight: "1.3"}}>
            <li><strong>Publication date:</strong> December 05, 2024</li>
            <li><strong>Publisher:</strong> Casemate</li>
            <li><strong>Page count:</strong> 384</li>
            <li><strong>Language:</strong> English</li>
            <li><strong>EPUB ISBN:</strong> 9781636244747</li>
            <li><strong>Paper ISBN:</strong> 9781636244730</li>
            <li><strong>File size:</strong> 13 MB</li>
          </ul>
        );
      default:
        return null;
    }
  };

  // if (loading)
  //   return (
  //     <div className="loading-container">
  //       <div className="spinner"></div>
  //       <p>Loading Issue Details...</p>
  //     </div>
  //   );
  // if (error)
  //   return (
  //     <div className="error-container">
  //       <div className="error-icon">⚠️</div>
  //       <p>Error: {error}</p>
  //     </div>
  //   );


  // if (loading) {
  //   return (
  //     <div className="flex items-center justify-center min-h-screen">
  //       <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
  //       <p className="ml-4 text-lg">Loading Issues Details...</p>
  //     </div>
  //   );
  // }
  


  return (
    <div className="issue-details section__padding-issue">
      <h1 className="issues-page__title" style={{ fontFamily: 'Poppins-Medium' }}>Issues</h1>
      <hr className="issues-page__divider-issue" />
      <div className="issue-details__container">
        <div className="issue-details__left">
          <img src={issue.coverImage} alt={`${issue.title} Cover`} className="issue-details__cover" />
          <button
            className="issue-details__button"
            onClick={() => window.open(issue.link, '_blank', 'noopener,noreferrer')}
          >
            Read Full Magazine
          </button>
          <button className="issue-details__button issue-details__button--secondary">
            Purchase the Hardcopy
          </button>
          <div className="issue-details__social">
            <a href="#" className="issue-details__social-link-issues">
              <FaInstagram />
            </a>
            <a href="#" className="issue-details__social-link-issues">
              <FaLinkedin />
            </a>
            <a href="#" className="issue-details__social-link-issues">
              <FaReddit />
            </a>
            <a href="#" className="issue-details__social-link-issues">
              <FaPinterest />
            </a>
          </div>
        </div>
        <div className="issue-details__right">
          <p className="issue-details__subtitle">Insulate Ukraine emerged from an approach of focusing</p>
          <h1 className="issue-details__title">{issue.title}</h1>
          <div className="issue-details__tags">
            <span className="issue-details__tag">Graphic Design</span>
            <span className="issue-details__tag">Industrial Design</span>
            <span className="issue-details__tag">Interior Design</span>
            <span className="issue-details__tag">Furniture Design</span>
          </div>
          <div className="issue-details__tabs">
            {['Description', 'Credits', 'Details'].map((tab) => (
              <button
                key={tab}
                className={`issue-details__tab ${activeTab === tab ? 'active' : ''}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
          <hr className="issues-page__divider-issue-sec" />
          <div className="issue-details__content">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IssueDetails;

